<img
  [class]="class"
  [ngClass]="{ hidden: isLoading }"
  [alt]="alt"
  [src]="src"
  loading="lazy"
  (load)="onLoad()"
  (error)="onError()"
/>
<div [ngClass]="{ hidden: !isLoading }" class="placeholder">
  <div class="loading-container">
    <!-- Place for a future loader -->
  </div>
</div>
